import { TextInput, useDataProvider } from 'react-admin';
import { useFormContext } from 'react-hook-form';
import { useEffect, useState } from 'react';

const OrderNum = ({ record }) => {
    const dataProvider = useDataProvider();
    const { setValue } = useFormContext();
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        if (!loaded) {
            dataProvider.getOne('ordernums', { id: 0 })
                .then(({ data }) => {
                    if (data?.Order_Num) {
                        setValue('Order_Num', data.Order_Num);
                        setLoaded(true);
                    }
                })
                .catch(error => {
                    console.error('Error fetching order number:', error);
                });
        }
    }, [dataProvider, setValue, loaded]);

    return (
        <TextInput
            disabled
            sx={{ marginTop: '0px', marginBottom: '0px', padding: '0px 4px 0px 2px;' }}
            source="Order_Num"
            label="Order Num"
        />
    );
};

export default OrderNum;
